export default __webpack_public_path__ + "../images/7.png";